module.exports = __webpack_public_path__ + "static/media/banner.367341eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TqlBuilder/banner.svg
// module id = 293
// module chunks = 0